import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pingceTitle, pingceList, homeHardAd, promoteInHome },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip id="260705" type="struct" title="评测标题" groupName="评测" content={pingceTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="287958"
                    type="recommend"
                    title="评测列表"
                    groupName="评测"
                    content={pingceList}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <NoSSR>
                    <Ad content={homeHardAd} styleName={styles.dbox} />
                </NoSSR>
                {promoteInHome && (
                    <Chip id="230195" type="struct" title="铺底推广" groupName="家居" content={promoteInHome}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
